<template>
  <div v-if="!isOnline" class="bg-primary fixed-bottom p-2">
    <div class="text-center text-white">
      <i class="material-icons align-middle">cloud_off</i>
      {{ $t('pwa.offline') }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isOnline: navigator.onLine,
    };
  },
  methods: {
    onLineCallback() {
      this.isOnline = true;
    },
    offLineCallback() {
      this.isOnline = false;
    },
  },
  created() {
    window.addEventListener('online', this.onLineCallback);
    window.addEventListener('offline', this.offLineCallback);
  },
};
</script>
